import { Injector, NgZone } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetGroup } from '../models/product/dto/asset-group';
import { UpdateAssetLibraryTypesModalComponent } from '../views/shared/modals/update-asset-library-types-modal/update-asset-library-types-modal.component';
import { ModalUtils } from '../utils/modal-utils';
import { exists } from '../functions/exists';

export class ModalUpdateAssetLibraryTypes {
  static open(
    ngZone: NgZone,
    ngbModal: NgbModal,
    injector: Injector,
    assetGroup: AssetGroup,
    onClose?: (ags: AssetGroup[]) => void
  ) {
    ngZone.run(() => {
      const modalRef = ngbModal.open(
        UpdateAssetLibraryTypesModalComponent,
        ModalUtils.updateAssetLibraryTypesModalOptions(injector)
      );
      const compInstance = modalRef.componentInstance as UpdateAssetLibraryTypesModalComponent;
      compInstance.setAssetGroup(assetGroup);
      modalRef.result
        .then(updateAssetGroups => {
          if (exists(updateAssetGroups)) {
            onClose?.(updateAssetGroups);
          }
        })
        .catch();
    });
  }
}
